/* globals $:false */

import ClipboardM from "../model/recordm.model.clipboard.js";
import DefinitionM from "../model/recordm.model.entity.definition.js";
import DefinitionSearchResultP from "../presenter/recordm.presenter.searchresult.definition.js";
import InstanceActions from "../actions/recordm.actions.instance.js";
import InstanceCreate from '../recordm.instance.create.js';
import InstanceDetail from '../recordm.instance.detail.js';
import InstanceDuplicate from '../recordm.instance.duplicate.js';
import InstanceGroupEdit from '../recordm.instance.groupedit.js';
import SearchVisGroupM from "../model/recordm.model.searchvisgroup.js";
import SimpleSearchM from "../model/recordm.model.simplesearch.js";
import SimpleSearchP from "../presenter/recordm.presenter.simplesearch.js";
import UriBuilder from "../helpers/module.uribuilder.js";

import tmpl_searchlist from '../templates/instance-field-references.dot';
import tmpl_searchlist_not_available from '../templates/instance-field-references-not-available.dot';
import utils from '@cob/ui-genesis/cob.utils.js';

// Component capable of showing RecordM instances that have fields referring the given instance field
//
// instanceId: the current instance id
// definitionName: the Definition name
// searchField: the definition field to search for
// searchFieldValue: the field value to search for (default: to the current instance id)
//
// confs:
// * 'activeVisualizationName': the visualization to apply to the search results (default: undefined)
// * 'createMode': If the field is going to be presented in an instance creation module (default: false)
// * 'groupEditMode': If the field is going to be presented in a group edition module (default: false)
// * 'searchFieldValue': The value to search for on the given search field
// * 'searchValueWithPlaceholders': If the initial search field value has placeholders (default: false)
// * 'showActions': shows the mass and instance actions buttons (default: false)
// * 'showImport': shows the import records button (default: false)
// * 'showViews':  enables the visualizations functionality (default: false)
// * 'showCreateAndDelete': shows the button for in-line instance creation (default: true)
//
const References = function(core, instanceId, definitionName, searchField, searchFieldValue, confs) {

    const _confs = {
        activeVisualizationName: undefined,
        createMode: false,
        groupEditMode: false,
        searchValueWithPlaceholders: false,
        showActions:false,
        showImport:false,
        showViews:false,
        showCreateAndDelete:true
    };

    utils.extend(_confs, confs, true);

    const fix_bool_option = function(opt){
        if (typeof opt == "string"){
            return (opt === "true" || opt === "1");
        }
        return opt;
    };
    _confs.showActions = fix_bool_option(_confs.showActions);
    _confs.showImport = fix_bool_option(_confs.showImport);
    _confs.showViews = fix_bool_option(_confs.showViews);
    _confs.showCreateAndDelete = fix_bool_option(_confs.showCreateAndDelete);


    const _esFormattedSearchField = utils.getEsFormattedFieldName(searchField);

    let _searchFieldValue = searchFieldValue || instanceId;

    const _$field = $(tmpl_searchlist({
        defSearchUrlText: core.translateString("recordm.instances", "instance.field.searchList.goto-def-search-url")
    }));

    // will be populated in afterRender
    let _container;

    let _searchP,
        _searchResultP,
        _definitionM,
        _simpleSearchM,
        _groupEdit,
        _activeVisualizationId;

    const _getQuery = function(fieldValue) {
        return `${_esFormattedSearchField}.raw:"${fieldValue}"`;
    };

    // If the search field value has placeholders, we do not define a query to prevent
    // showing results to the user while the search field value has placeholders
    let _query = (_confs.searchValueWithPlaceholders
                  ? undefined
                  : _getQuery(_searchFieldValue));

    const _getUrlForDefinitionSearch = function(defId, query) {
        return "#/" + UriBuilder.buildUriForSimpleSearchDefinition(defId, query, _activeVisualizationId);
    };

    const _removeUnnecessarySearchResultsHtml = function() {

        if (!_confs.showActions) {
            // Remove the batch actions container, as it won't show any available option
            // It also improves the custom data elements (added in customizations scripts) location
            $(".js-mass-actions-left-container", _$field).remove();
        }
        if (!_confs.showViews) {
            //Remove the view selection info container
            $(".result-views-container", _$field).remove();
        } else{
            $(".result-views-container").addClass("pull-right")
        }


        //Remove the total records container
        $(".js-total-records-container", _$field).remove();
    };

    const _updateTotalResults = function(numResults) {
        $(' > div.references-wrapper > div.references-legend > span.js-total-records', _container).text(numResults);
    };

    const _onSearchFinished = function() {
        const numResults = _simpleSearchM.getTotalMatchingResults();

        _updateTotalResults(numResults);

        $(".references-new-wrapper", _container).first().attr("style","margin-top:10px;position:relative");
    };

    const _clearInlineContainer = function(){
        $(".js-references-new-wrapper", _container).empty();
    };

    const _addNewInstanceLink = function(defId) {
        _updateNewInstanceLink(defId);
        $(".js-references-new-instance-link", _container).removeClass("hidden");
    };

    const _updateNewInstanceLink = function(defId) {
        const _clipboardPairs = [
            {
                "targetField": searchField,
                "value": _searchFieldValue
            }
        ];
        const newInstanceData = new ClipboardM().buildClipboardObject(_clipboardPairs);
        const newInstanceDataStr = JSON.stringify(newInstanceData);

        const newInstanceUrl = `#/${UriBuilder.buildUriForCreateInstance(defId, newInstanceDataStr)}`;

        $(".js-references-new-instance-link", _container).attr("href", newInstanceUrl);

        _container.off('click', ".js-references-new-instance-link");
        _container.on('click', ".js-references-new-instance-link", function(e){
           e.preventDefault();
           e.stopPropagation();

           if ($(".js-instance-create-container", _container).length === 0){
               _clearInlineContainer();

              const create = InstanceCreate(core, {
                 container: $(".js-references-new-wrapper", _container),
                 exitLabel: 'action.cancel',
                 exit: function(){
                    create.destroy();
                 },
                 afterSave: function(){
                    create.destroy();
                    setTimeout(() => _searchP.refresh(), 500);
                 }
              });
              create.init(defId, newInstanceDataStr);
           }
        })
    };

    const _removeNewInstanceLink = function() {
        $(".js-references-new-instance-link", _container).remove();
    };

    const _updateGoToSearchLink = function() {
        $(".js-def-search-link", _$field).attr("href",
            _getUrlForDefinitionSearch(_definitionM.getId(), _query));
    };

    const _duplicateInstanceActionOverride = function(instanceId) {
        _clearInlineContainer();

        const duplicate = InstanceDuplicate(core, {
            container: $(".js-references-new-wrapper", _container),
            exitLabel: 'action.cancel',
            exit: function() {
                duplicate.destroy();
            },
            afterSave: function() {
                duplicate.destroy();
                setTimeout(() => _searchP.refresh(), 500);
            }
        });
        duplicate.init(instanceId);
    };

    const _groupEditActionOverride = function(definitionId, ids, query) {
        _clearInlineContainer();

         _groupEdit = InstanceGroupEdit(core, {
            container: $(".js-references-new-wrapper", _container),
            exitLabel: 'action.cancel',
            exit: function() {

                _groupEdit.destroy();
            },
            afterSave: function() {
                _groupEdit.destroy();
                setTimeout(() => _searchP.refresh(), 3000);
            }
        });
        _groupEdit.init(_definitionM.getId(), query, ids, undefined);
    };

    const _onDetailsClicked = function(el, instanceId) {
        const $el = $(el);
        //Hack to avoid dblclick (it would add the container twice
        if($el.data('clicked')){
            return false;
        }else{
            // Mark to ignore next click  and Unmark after 1 second
            $el.data('clicked', true);
            window.setTimeout(function(){
                $el.removeData('clicked');
            }, 1000)

            //Do the stuff ...
            _clearInlineContainer();

            const update = InstanceDetail(core, {
                container: $(".js-references-new-wrapper", _container),
                exitLabel: 'action.cancel',
                exit: function(){
                    update.destroy();
                },
                afterSave: function(){
                    update.destroy();
                    setTimeout(() => _searchP.refresh(), 500);
                }
            });
            update.init(instanceId, undefined);
        }
    };

    const _addRefreshBtnListener = function() {
        _container.on("click", ".js-references-refresh-btn", function(e) {
            e.preventDefault();

            if (_searchP) {
                _searchP.refresh();
            }
        });
    };

    const _getActiveVisualizationIdByName = function(viewName, views) {
        const viewM = views.find((settingM) => settingM.getKey() === viewName);

        return (viewM !== undefined
                ? viewM.getId()
                : undefined);
    };

    const _onSelectedRowsChanged = function(e, data){
        if(!_groupEdit) return;
        console.debug('JB selection changed', data)
        const geditIds = _groupEdit.getIds() ? _groupEdit.getIds() : "";

        if( ( geditIds === "" && data.selectedIds.length > 0)
            || geditIds.split(",").length !== data.selectedIds.length
            || _groupEdit.getQuery() !== data.query) {

            _groupEdit.updateSelectedIds( data.allSelected ? data.query : undefined , data.selectedIds)
        }
    }

    const _initDefinitionPs = function(views) {
        const visualizationGroupM = new SearchVisGroupM(core, _definitionM, views);

        _activeVisualizationId = (_confs.activeVisualizationName
                                       ? _getActiveVisualizationIdByName(_confs.activeVisualizationName, views)
                                       : undefined);

        const activeVisualization = (_activeVisualizationId
                                     ? visualizationGroupM.get(_activeVisualizationId)
                                     : undefined);

        _simpleSearchM = new SimpleSearchM(
            core,
            "recordm/definitions/search/" + _definitionM.getId(),
            "recordm/definitions/search/download/" + _definitionM.getId()
        );

        const $resultsContainer = $(".js-def-search-result-container", _$field);

        _searchP = new SimpleSearchP(core, undefined, _definitionM, _simpleSearchM, undefined,
            {"advance-search": false},
            {
                getCurrentVisualization: function() {
                    return activeVisualization;
                }
            });


        let _instanceActions;
        if (_confs.showActions) {
            _instanceActions = new InstanceActions(core, {
                disableDelete: !_confs.showCreateAndDelete,
                duplicateInstanceOverride: _duplicateInstanceActionOverride,
                groupEditOverride: _groupEditActionOverride
            });
        }

        _searchResultP = new DefinitionSearchResultP(core, _simpleSearchM, _definitionM, visualizationGroupM,
            _instanceActions, $resultsContainer, {
                canCreateNewRecord: false,
                canDuplicate: _confs.showActions && _confs.showCreateAndDelete && _definitionM.data._links && _definitionM.data._links.instantiate,
                canImportRecords: _confs.showImport,
                canPrint: false,
                onDetailsClicked:_onDetailsClicked
            });

        _searchP.init(_query);
        _searchResultP.init(_query, _activeVisualizationId);

        core.subscribe("definition-search:results-ready", _onSearchFinished);
        core.subscribe("recordm:search-selection-changed", _onSelectedRowsChanged);
    };

    const _init = function() {
        // If "searchFieldValue" is undefined it means the search value is the instance id and so we do not
        // show this field when creating an instance (id not available)
        // If searchFieldValue is defined, it means the search value does not depend on the instance id
        // and so we can show it when creating as instance (not when editing multiple instances)
        if (_confs.groupEditMode || (searchFieldValue === undefined && _confs.createMode)) {
            return;
        }

        DefinitionM.getByName(core, definitionName, function(definitionM) {
            _definitionM = definitionM;

            SearchVisGroupM.loadAll(core, definitionM.getSettingKey(), function(views) {
                _initDefinitionPs(views);

                _removeUnnecessarySearchResultsHtml();

                const hasCreationPerm = definitionM.data._links && definitionM.data._links.instantiate;

                if (_confs.showCreateAndDelete && hasCreationPerm) {
                    _addNewInstanceLink(_definitionM.getId());
                } else {
                    _removeNewInstanceLink();
                }

                _addRefreshBtnListener();

                //Update the "open in new tab" link href
                _updateGoToSearchLink();
            });

        });
    };

    const _render = function() {
        // If "searchFieldValue" is undefined it means the search value is the instance id and so we do not
        // show this field when creating an instance (id not available)
        // If searchFieldValue is defined, it means the search value does not depend on the instance id
        // and so we can show it when creating as instance (not when editing multiple instances)
        if (_confs.groupEditMode || (searchFieldValue === undefined && _confs.createMode)) {
            return tmpl_searchlist_not_available({
                msg: core.translateString("recordm.instances", _confs.groupEditMode
                                                               ? "instance.field.searchList.not-available-on-groupedit"
                                                               : "instance.field.searchList.not-available-on-create")
            });
        }

        return _$field;
    };

    const _destroy = function() {
        _$field.remove();

        _container.off("click");

        core.unsubscribe("recordm:search:finished", _onSearchFinished);
        core.unsubscribe("recordm:search-selection-changed", _onSelectedRowsChanged);

        if (_searchP) _searchP.destroy();
        if (_searchResultP) _searchResultP.destroy();
    };

    const _dummy = function() {
        //do nothing
    };

    _init();

    return {
        render: _render,
        afterRender: (view) => {
            _container = $(view.getContainer()[0]);
        },
        destroy: _destroy,

        clearError: _dummy,
        showError: _dummy,

        setValue: _dummy,
        getValue: function() {
            return undefined;
        },
        disableSelf: _dummy,
        setSearchValue: function(newSearchValue) {
            const newQuery = _getQuery(newSearchValue);

            if (newQuery !== _query) {
                _searchFieldValue = newSearchValue;
                _query = newQuery;

                if (_searchP) _searchP.doSearch(_query);
            }

            if (_definitionM) {
                _updateGoToSearchLink();
                _updateNewInstanceLink(_definitionM.getId());
            }
        }
    }
};

export default References;
